import { render } from "./IconCommonFile.vue?vue&type=template&id=8657211c"
import script from "./IconCommonFile.vue?vue&type=script&lang=ts"
export * from "./IconCommonFile.vue?vue&type=script&lang=ts"
script.render = render

export default script